import splashPage from './js/splashPage.js';

// Widget scripts
import cardWidgetAmpHeaderBanner from './js/widgets/cardWidgetAmpHeaderBanner.js';
import headerOnloadContent from './js/headerOnloadContent.js';
import cardWidgetAmpCountdown from './js/widgets/cardWidgetAmpCountdown.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetSEO from './js/widgets/cardWidgetSEO.js';
import cardWidgetOncUpcomingEvents from './js/widgets/cardWidgetOncUpcomingEvents.js';
import cardWidgetFeaturedEvents from './js/widgets/cardWidgetFeaturedEvents.js';
import cardWidgetAmpCircles from './js/widgets/cardWidgetAmpCircles.js';
import cardWidgetAmpSocialNetworks from './js/widgets/cardWidgetAmpSocialNetworks.js';
import cardWidgetBannerAd from './js/widgets/cardWidgetBannerAd.js';
import cardWidgetOncSlidingCards from './js/widgets/cardWidgetOncSlidingCards.js';
import ampthitheaterMap from './js/amphitheaterMap.js';
import oncenterMap from './js/oncenterMap.js';
import cardWidgetPolaroids from './js/widgets/cardWidgetPolaroids.js';
import cardWidgetSponsors from './js/widgets/cardWidgetSponsors.js';
import cardWidgetPartners from './js/widgets/cardWidgetPartners.js';


// load bluebird if IE
const bIE = /*@cc_on!@*/false || !!document.documentMode;
if (bIE) {
  $.getScript(`${SITEBASEURL}Events/JS/bluebird.js`);
}

const docReferrer = document.referrer;
const urlVar = window.location.search;
if (docReferrer.includes('oncenter.org') || urlVar === '?th=oncenter' || urlVar.includes('th=oncenter')) {
  sessionStorage.setItem('siteTheme', 'Oncenter');
}

if (docReferrer.includes('sjhamphitheater.com') || urlVar.includes('th=amphitheater') || urlVar.includes('t=amphitheater')) {
  sessionStorage.setItem('siteTheme', 'Amphitheater');
  if (window.location.pathname === '/') {
    window.location.href = `${SITEBASEURL}p/amphitheater`;
  }
}

let siteTheme = sessionStorage.getItem('siteTheme');
const hasOncClass = $('body').hasClass('site-oncenter');
const hasAmpClass = $('body').hasClass('site-amphitheater');
const path = window.location.pathname;
const ampHomepage = path === '/p/amphitheater' ? true : false;


if ((path === '/') && (siteTheme === 'Amphitheater')) {
  siteTheme = 'Oncenter';
  sessionStorage.setItem('siteTheme', 'Oncenter');
}
if (ampHomepage && (siteTheme === 'Oncenter')) {
  siteTheme = 'Amphitheater';
  sessionStorage.setItem('siteTheme', 'Amphitheater');
}


if (hasAmpClass) {
  $('body').removeClass('site-oncenter');
  sessionStorage.setItem('siteTheme', 'Amphitheater');
  siteTheme = 'Amphitheater';
} 

if (hasOncClass) {
  $('body').removeClass('site-amphitheater');
  sessionStorage.setItem('siteTheme', 'Oncenter');
  siteTheme = 'Oncenter';
}

if (!hasAmpClass && !hasOncClass) {
  if (siteTheme === 'Oncenter') {
    $('body').addClass('site-oncenter');
  }
  if (siteTheme === 'Amphitheater') {
    $('body').addClass('site-amphitheater');
  }
  if (siteTheme === null) {
    $('body').addClass('site-oncenter');
    console.log(siteTheme)
    siteTheme = 'Oncenter';
    splashPage();
  }
}

console.log(siteTheme)
window.siteTheme = siteTheme;

if (ampHomepage) {
  $('body').addClass('amp-homepage');
}

// Note: there is also a small script in Content Placeholders in Spark relating to determining the theme for Modals.

// Custom theme scripts
import './js/localjs.js';



// Initialize widgets
if (siteTheme === 'Amphitheater') {
  $(document).ready(function() {
    cardWidgetAmpHeaderBanner();
    cardWidgetPolaroids();
    cardWidgetSponsors();
    cardWidgetPartners();
    cardWidgetAmpSocialNetworks();
    cardWidgetBannerAd();    
    if (ampHomepage) {
      headerOnloadContent();
      swiperWidget();
      cardWidgetAmpCountdown();
      cardWidgetSEO();
      cardWidgetFeaturedEvents();
      cardWidgetAmpCircles();    
      ampthitheaterMap();    
    }  
  });
}  

if (siteTheme === 'Oncenter') {
  $(document).ready(function() {
    cardWidgetPolaroids();
    cardWidgetSponsors();
    cardWidgetPartners();
    cardWidgetBannerAd();    
    if ($('body').hasClass('homepage')) {
      headerOnloadContent();
      swiperWidget();
      cardWidgetOncUpcomingEvents();
      cardWidgetFeaturedEvents();
      cardWidgetSEO();
      cardWidgetOncSlidingCards();
      oncenterMap();
    }
  });
}  

